import React, {useState, useEffect} from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import DownIcon from '@mui/icons-material/KeyboardArrowDown';
import styledComponent from 'styled-components';
import CardLoadingSvg from '../../../../Images/cardLoading.svg';
import { useDispatch, useSelector } from 'react-redux';
import { complexidadeUpdate, complexidadeAdd } from '../../../../Services/cardService';

const BootstrapButton = styled(Button)({
	boxShadow: 'none',
	textTransform: 'none',
	gap: '0.25rem',
	padding: '0.25rem 0.5rem',
	color: 'black',
	backgroundColor: 'rgba(0, 0, 0, 0.03)',
	border: 'none',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-around',

	'&:hover': {
		backgroundColor: 'rgba(255, 255, 255, 0.2)',
	},
	'&:active': {
		backgroundColor: 'rgba(255, 255, 255, 0.2)',
	},
});

const LoadingBox = styledComponent.div`
	height: 3rem;
	width: 8rem;
	padding: 0.5rem 3rem;
	background-image: url(${(props) => props.image});
	background-position: center;
	background-repeat: no-repeat;
`;

const Span = styledComponent.span`
font-size: 0.85rem;
display:block;
`;

const StyledIcon = styled(DownIcon)({
	display: 'block',
	fontSize: '1.3rem',
});

export default function DropdownComplexidade(props) {
	const thisCard = useSelector((state) => state.card);
	const dispatch = useDispatch();

	const dadosComplexidade = [
		{ _id: '1', description: '1 - Sem Complexidade' },
		{ _id: '2', description: '2 - Pouco Complexo'},
		{ _id: '3', description: '3 - Complexo'},
		{ _id: '4', description: '4 - Muito Complexo'},
		{ _id: '5', description: '5 - Extremamente Complexo'},
	];

	const [complexidadeData, setComplexidadeData] = React.useState(dadosComplexidade);
	const [complexidade, setComplexidade] = useState(thisCard.complexidade);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [loading, setLoading] = React.useState(false);
  const [selectedComplexidade, setSelectedComplexidade] = React.useState(null);

	const open = Boolean(anchorEl);
	const handleClick = async (event) => {
		setAnchorEl(event.currentTarget);
    setLoading(true);
    try {
  
    } catch (error) {
        console.error("Falha ao buscar quadros:", error);
    } finally {
        setLoading(false);
    }
	};

	useEffect(() => {			
		if (complexidade) {			
			const selected = complexidadeData.find((p) => p.description === complexidade.toString());			
			if (selected) 
				{setSelectedComplexidade(selected);}
		}
	}, [complexidade, complexidadeData]);

  const handleSelect = async (item) => {
    setSelectedComplexidade(item); 
    setAnchorEl(null);
		
		await complexidadeAdd(thisCard.cardId, thisCard.listId, thisCard.boardId, item.description, dispatch);		
 };

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<div>
			<BootstrapButton
				id='demo-positioned-button'
				aria-controls='demo-positioned-menu'
				aria-haspopup='true'
				aria-expanded={open ? 'true' : undefined}
				onClick={handleClick}
			>
				<Span>{selectedComplexidade?.description || props.description || 'Selecione'}</Span>
				<Span>
					<StyledIcon />
				</Span>
			</BootstrapButton>
			{Object.keys(complexidadeData).length > 0 && (
				<Menu
					id='demo-positioned-menu'
					aria-labelledby='demo-positioned-button'
					anchorEl={anchorEl}
					open={open}
					onClose={handleClose}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
				>
					{!loading ? (
						complexidadeData.map((item) => {
							return (
								<MenuItem
									key={item._id}
                  onClick={() => handleSelect(item)}
								>
									<Span>{item.description}</Span>
								</MenuItem>
							);
						})
					) : (
						<LoadingBox image={CardLoadingSvg} />
					)}
				</Menu>
			)}
		</div>
	);
}
